// extracted by mini-css-extract-plugin
export default {"Quote":"Quote_Quote__xXmlK","Image":"Quote_Image__GzfS-","fadeInFromBlack":"Quote_fadeInFromBlack__7tNCN","fadeInLeft":"Quote_fadeInLeft__fdmlG"};